import PropTypes from 'prop-types';

import Breadcrumb from 'shopper/components/Breadcrumb/V1/Breadcrumb';

import BreadcrumbItem from 'components/Breadcrumb/Item';

import placeholder from 'lib/placeholder';

import LINKS from 'constants/links';

const ForumBreadcrumb = ({ categoryTitle = null }) => (
  <Breadcrumb>
    <BreadcrumbItem
      data-test-selector="home-page-breadcrumb-item"
      href={LINKS.HOME}
    >
      {placeholder('breadcrumbs.app')}
    </BreadcrumbItem>
    <BreadcrumbItem href={categoryTitle ? LINKS.FORUM : null}>
      {placeholder('breadcrumbs.forum')}
    </BreadcrumbItem>
    {categoryTitle && <BreadcrumbItem>{categoryTitle}</BreadcrumbItem>}
  </Breadcrumb>
);

ForumBreadcrumb.propTypes = {
  categoryTitle: PropTypes.string,
};

export default ForumBreadcrumb;
